import {match} from 'ts-pattern';

import {OAuthProviders, SmtpEmailProviderCode} from '@dms/api/core';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

export const getCredentialsProviderLabel = (
  type: SmtpEmailProviderCode | OAuthProviders | Nullish
) =>
  match(type)
    .with('gmail-smtp', () => 'Gmail')
    .with('microsoft', 'microsoft-oauth', () => 'Microsoft')
    .with('outlook-smtp', () => 'Outlook')
    .with('seznam-smtp', () => 'Seznam')
    .otherwise(() => i18n.t('general.labels.custom'));
